import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, KeyRound, Database, GitBranch, Network } from 'lucide-react';
import { ACCELERATORS } from '../mock';
import ClosingCTA from '../components/ClosingCTA';

const icons = [<KeyRound size={24} />, <Database size={24} />, <GitBranch size={24} />, <Network size={24} />];

export default function NeuralWorksAccelerators() {
  return (
    <div>
      <section className="pt-16 pb-10">
        <div className="dwx">
          <Link to="/neuralworks" className="inline-flex items-center gap-2 mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/60 hover:text-[#1A1A1A]">
            <ArrowLeft size={14} /> Back to NeuralWorks
          </Link>
          <h1 className="serif-tight text-[54px] md:text-[92px] leading-[0.94] mt-6">Accelerators.</h1>
          <p className="mt-6 max-w-3xl text-[17px] leading-relaxed text-[#1A1A1A]/80">The named proprietary components inside NeuralWorks. Each one has a specific problem it solves — and a specific thing it will not do.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="dwx grid grid-cols-1 md:grid-cols-2 gap-4">
          {ACCELERATORS.map((a, i) => (
            <div key={a.name} className="rounded-[24px] bg-[#F4F2EC] p-10 border border-[#1A1A1A]/10 lift">
              <div className="flex items-center justify-between">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#22A94F]/20 text-[#178838]">{icons[i]}</div>
                <span className="mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/50">0{i + 1}</span>
              </div>
              <h3 className="serif text-[30px] leading-tight mt-6">{a.name}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-[#1A1A1A]/80">{a.description}</p>
            </div>
          ))}
        </div>
      </section>

      <ClosingCTA />
    </div>
  );
}
